<template>
  <section
    class="pt-[135px] pb-5 max-[1199px]:pt-[63px] max-[1199px]:pb-5 md:pb-[50px] min-[1200px]:pb-[104px]"
  >
    <div class="mx-auto w-full max-w-container">
      <h2 class="mb-0 mt-0 font-extrabold text-[#333] pl-8">
        <Translate translate-key="landing_safety.title" />
      </h2>
      <ul class="mx-0 mt-0 grid list-none grid-cols-1 gap-6 p-0 md:grid-cols-3">
        <li
          v-for="(card, index) in safetyCards"
          :key="index"
          class="flex flex-col rounded-xl bg-white p-6 mx-9 md:mx-0 pb-5 pt-[50px] shadow-xl max-[1199px]:pt-[65px] md:pb-10"
        >
          <div class="mb-2 flex items-center gap-4">
            <NuxtImg
              src="/safety/shield.png"
              width="54"
              height="54"
              format="webp"
              alt="Safety shield icon"
              loading="lazy"
              class="h-[54px] w-[54px] shrink-0"
            />
            <h3 class="m-0 text-[#333] font-semibold">
              <Translate :translate-key="card.subtitleKey" />
            </h3>
          </div>
          <p class="mb-0 text-[#666]">
            <Translate :translate-key="card.textKey" />
          </p>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
import Translate from "~/shared/components/i18n/Translate/Translate.vue";

const safetyCards = [
  {
    subtitleKey: "landing_safety.subtitle",
    textKey: "landing_safety.text_1",
  },
  {
    subtitleKey: "landing_safety.subtitle_2",
    textKey: "landing_safety.text_2",
  },
  {
    subtitleKey: "landing_safety.subtitle_3",
    textKey: "landing_safety.text_3",
  },
];
</script>
